<template>
  <div class="integral-rule">
    <img src="@/assets/images/training/img(22).png" class="rule-bg" alt="">
    <div class="rule-list" :class="isPc ? 'isPc' : ''">
      <img src="../../assets/images/training/img(36).png" class="rule-top-img" alt="">
      <div class="rule-item">
        <div class="item-txt1">1.学术内容关注积分</div>
        <div class="item-txt2">(课程观看min+直播观看min) / 3min *1分+ (文献浏览篇数+病例浏览个数+ Onepage复盘点击次数）*1分</div>
      </div>
      <div class="rule-item">
        <div class="item-txt1">2.主动行为交互积分</div>
        <div class="item-txt2">(转发+点赞+收藏+评论/留言次数+搜索次数+评分+训练营评价+直播预约+投票次数) *1分+ (答题次数+提交作业次数+ iEP班级考试次数) *2分</div>
      </div>
      <div class="rule-item">
        <div class="item-txt1">3.累计登录积分</div>
        <div class="item-txt2">登录天数 *1分</div>
      </div>
      <div class="rule-item">
        <div class="item-txt1">4.学术分享意愿积分</div>
        <div class="item-txt2">病例社区上传病例数 *15分</div>
      </div>
      <div class="rule-item">
        <div class="item-txt1">5.勋章积分</div>
        <div class="item-txt2">1.连登先锋+10积分；2.知识富翁+20积分；3.心电大师+50积分</div>
      </div>
      <div class="rule-item">
        <div class="item-txt1">6.好术者比赛积分</div>
        <div class="item-txt2">每参与一场答题完成+20积分</div>
      </div>
    </div>
  </div>
</template>
<script>
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data() {
    return {
      isPc: false
    }
  },
  mounted() {
    var system = {
      win: false,
      mac: false,
      x11: false,
      ipad: false
    }
    // 检测平台
    var p = navigator.platform
    system.win = p.indexOf('Win') > -1
    if (system.win) {
      this.isPc = true
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.integral-rule {
  position: relative;
  padding: 67px 10px 25px;
  box-sizing: border-box;
  height: 100vh;
  background-color: #F2F7FA;

  .rule-bg {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }

  .rule-top-img {
    position: absolute;
    left: 50%;
    top: 0;
    width: 124px;
    transform: translateX(-50%);
    z-index: 9;
  }

  .rule-list {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 10px;
    padding: 46px 12px 0;
    box-sizing: border-box;
    position: relative;
    overflow-y: auto;

    &.isPc {
      .rule-item {
        .item-txt1 {
          color: #EB1700;
        }
      }
    }

    .rule-item {
      margin-bottom: 24px;

      .item-txt1 {
        font-size: 14px;
        line-height: 24px;
        color: #EB1700;
        margin-bottom: 8px;
        font-weight: 600;
      }

      .item-txt2 {
        font-size: 14px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/person/integralRule.vue